import { ArrowLeft } from "feather-icons-react/build/IconComponents";
import { t } from "i18next";
import { useContext, useEffect, useState } from "react";
import API from "../../../API/newIndex";
import { ChangePathContext } from "../../../App";
import Breadcrumbs from "../../../controllers/breadCrumbs";
import generatePin from "../../../controllers/generatePin";
import { parentNavigate } from "../../../controllers/ParentNavigate";
import Notification from "../../Notification";
import {
  ButtonComponent,
  DetailsComponent,
  InputComponent,
  SelectComponent,
} from "@shopeasy-dashboard-ui/ui-library";

function AddPosStaff() {
  const { saveChanges, setSaveChanges } = useContext(ChangePathContext);
  const [isNotification, setIsNotification] = useState(false);
  const [notificationMsg, setNotificationMsg] = useState("");
  const [severity, setSeverity] = useState();
  const [warn, setwarn] = useState(false);
  const [staffData, setStaffData] = useState({
    first_name: "",
    last_name: "",
    phone: "",
    email: "",
    pin: "",
    pos_location: [],
  });
  const [validEmail, setValidEmail] = useState(false);
  const [validEmailErr, setValidEmailErr] = useState(false);
  const [locationData, setLocationData] = useState([]);
  const [planPermission, setPlanPermission] = useState({
    isPlanPermissions: false,
    forModule: "",
  });

  const HandleInput = (e) => {
    if (e.target.name === "email") {
      setValidEmailErr(false);
    }
    setStaffData({ ...staffData, [e.target.name]: e.target.value });
  };
  const emailVerify = async () => {
    if (staffData?.email?.length >= 3) {
      try {
        const storeApiData = await API({
          url: `/super/admin/tenant/validemail/${staffData?.email}`,
          method: "get",
        });
        if (storeApiData.status === 200 || storeApiData.status === 304) {
          setValidEmail(true);
          setValidEmailErr(false);
        }
      } catch (error) {
        setIsNotification(true);
        setNotificationMsg(t("lang_Email_is_invalid"));
        setSeverity("error");
        setValidEmail(false);
        setValidEmailErr(true);
      }
    }
  };
  const [err, setErr] = useState();
  const [btnLoading, setBtnLoading] = useState(false);
  const getLocation = async () => {
    try {
      let ApiCall = await API({ url: `/admin/pos/getPOSLocations`, method: "get" });
      if (ApiCall.status === 200 || ApiCall.status === 304) {
        const result = ApiCall?.data;
        setLocationData(result);
      }
    } catch (error) {
      if (error?.response?.status === 882) {
        setPlanPermission({ isPlanPermissions: false, forModule: "pos" });
      }
      setIsNotification(true);
      setNotificationMsg(error);
      setSeverity("error");
    }
  };
  useEffect(() => {
    getLocation();
  }, []);
  const HandleSubmit = async (e) => {
    e.preventDefault();
    setBtnLoading(true);
    try {
      const payload = staffData;
      await API({ url: "/admin/pos/addPOSstaff", method: "post", data: payload });
      setIsNotification(true);
      setNotificationMsg("Staff Added Successfully!");
      setSeverity("success");
      setSaveChanges({
        isUnsaveChanges: false,
        showChangesPopup: false,
        backLink: "/pos/staff",
        title: "add staff",
      });
      parentNavigate("/pos/staff");
    } catch (error) {
      setIsNotification(true);
      setNotificationMsg(error);
      setSeverity("error");
    }
    setBtnLoading(false);
  };
  const handleClose = () => {
    setIsNotification(false);
    setNotificationMsg("");
    setSeverity("");
  };

  useEffect(() => {
    if (
      staffData?.email?.length > 0 ||
      staffData?.pin?.length > 0 ||
      staffData?.pos_location?.length > 0
    ) {
      setSaveChanges({
        backLink: "/pos/staff",
        isUnsaveChanges: true,
        showChangesPopup: false,
        title: "add staff",
      });
    } else {
      setSaveChanges({
        backLink: "/pos/staff",
        isUnsaveChanges: false,
        showChangesPopup: false,
        title: "add staff",
      });
    }
  }, [staffData]);
  const checkChanges = () => {
    if (
      staffData?.email?.length > 0 ||
      staffData?.pin?.length > 0 ||
      staffData?.pos_location?.length > 0
    ) {
      setSaveChanges({
        isUnsaveChanges: true,
        showChangesPopup: true,
        backLink: "/pos/staff",
        title: "add staff",
      });
    } else {
      parentNavigate("/pos/staff");
    }
  };

  const locationOptions = (locationData || []).map((item) => ({
    value: item?._id,
    label: item?.name,
  }));

  return (
    <>
      {isNotification && notificationMsg && (
        <Notification message={notificationMsg} close={handleClose} severity={severity} />
      )}

      <div className="h-auto overflow-y-auto pb-[65px] pt-5">
        <div className="px-[20px]">
          <div className="w-full lg:w-[70%] xl:w-[60%] mx-auto">
            <div className="flex items-center space-x-2">
              <button
                onClick={(e) => {
                  e.preventDefault();
                  checkChanges();
                }}
                className="back-arrow -ml-3.5"
              >
                <ArrowLeft />
              </button>
              <div className="flex-1 min-w-0">
                <Breadcrumbs
                  crumbs={[
                    { name: t("lang_POS"), path: "/pos/staff" },
                    {
                      name: t("lang_Add_Staff"),
                      path: "/pos/staff/add",
                    },
                  ]}
                />
                <div className="flex flex-wrap items-center gap-2 sm:gap-3 mt-1">
                  <h4 className="text-xl md:text-2xl font-semibold text-primary">
                    {t("lang_Add_Staff")}
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="p-[20px]">
          <div className="w-full lg:w-[70%] xl:w-[60%] mx-auto space-y-4">
            <form onKeyDown={(e) => e.key === "Enter" && e.preventDefault()} className="space-y-4">
              <DetailsComponent
                open={true}
                hasHr={false}
                showChevron={false}
                className="!pt-5 sm:!pt-[25px]"
              >
                <div className="p-5 sm:p-[25px] pt-0 sm:pt-0 flex flex-col gap-4">
                  <InputComponent
                    id="first_name"
                    name="first_name"
                    label={t("lang_firstname")}
                    value={staffData?.first_name}
                    onChange={(e) => {
                      HandleInput(e);
                      setwarn(false);
                    }}
                    placeholder={t("lang_Write_Your_First_Name")}
                  />
                  <InputComponent
                    id="last_name"
                    name="last_name"
                    label={t("lang_lastname")}
                    value={staffData?.last_name}
                    onChange={(e) => {
                      HandleInput(e);
                      setwarn(false);
                    }}
                    placeholder={t("lang_Write_Your_Last_Name")}
                  />
                  <InputComponent
                    id="phone"
                    name="phone"
                    label={t("lang_phone")}
                    value={staffData?.phone}
                    onChange={(e) => {
                      HandleInput(e);
                      setwarn(false);
                    }}
                    placeholder={t("lang_Write_Your_Phone")}
                  />
                  <InputComponent
                    id="email"
                    name="email"
                    label={t("lang_email")}
                    required
                    value={staffData?.email}
                    onChange={(e) => {
                      HandleInput(e);
                      setwarn(false);
                    }}
                    onBlur={emailVerify}
                    placeholder={t("lang_Write_Your_Email")}
                    error={
                      err && !staffData?.email
                        ? t("lang_Please_Enter_Email")
                        : validEmailErr
                          ? t("lang_Email_is_invalid")
                          : warn
                            ? t("lang_Please_Enter_Email")
                            : ""
                    }
                  />
                  <InputComponent
                    id="pin"
                    name="pin"
                    type="number"
                    label={t("lang_PIN")}
                    required
                    value={staffData?.pin}
                    onChange={(e) => {
                      if (e.target.value?.length <= 4 || e.target.value?.length <= 6) {
                        HandleInput(e);
                        setwarn(false);
                      }
                    }}
                    placeholder={t("lang_Write_Your_Pin")}
                    suffix={
                      <ButtonComponent
                        variant="outline"
                        size="sm"
                        onClick={() => setStaffData({ ...staffData, pin: generatePin() })}
                      >
                        {t("lang_generate_PIN")}
                      </ButtonComponent>
                    }
                    error={
                      err && !staffData?.email
                        ? t("lang_Please_Enter_Your_Pin")
                        : warn
                          ? t("lang_Please_Enter_Your_Pin")
                          : ""
                    }
                  />
                  <SelectComponent
                    id="pos_location"
                    name="pos_location"
                    label={t("lang_Location")}
                    required
                    multiple
                    placeholder={t("lang_Select_Location")}
                    options={locationOptions}
                    value={staffData?.pos_location}
                    onChange={(e) => {
                      setStaffData({
                        ...staffData,
                        pos_location: e.target.value,
                      });
                    }}
                  />
                </div>
              </DetailsComponent>
            </form>
          </div>
        </div>
        <div className="flex items-center shadow fixed justify-between w-full bottom-[0px] z-50 secondary-bg-color border-t main-border-color p-3 left-0">
          <div className="w-[90%] flex items-center justify-between lg:w-[70%] xl:w-[58%] mx-auto">
            <ButtonComponent
              variant="link"
              onClick={(e) => {
                e.preventDefault();
                checkChanges();
              }}
              icon={<ArrowLeft className="w-3 mr-1" />}
              className="text-primary"
            >
              {t("lang_Go_To_POS")}
            </ButtonComponent>
            <div>
              <ButtonComponent
                variant="primary"
                loading={btnLoading}
                disabled={
                  !staffData?.email ||
                  staffData?.pin?.length < 4 ||
                  staffData?.pos_location?.length <= 0 ||
                  !validEmail
                }
                onClick={(e) => HandleSubmit(e)}
              >
                {t("lang_Add_Staff")}
              </ButtonComponent>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddPosStaff;
